import { SelectionCardGroupProps, Stack } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { lt, FormSelectionCardGroupField } from '@mews/framework';
import { ClaimedProductsBy, FilterValueKey } from '../types';
import { FILTERS_SPACING, ProductCheckListFilterFieldsDataTestId } from '../constants';
import { ProductCheckListTableColumn } from '../../../../containers/ProductCheckListTable/types';

export const displayedColumnsOption: SelectionCardGroupProps['options'] = [
    {
        label: lt(TextKey.OwnerPlural),
        name: ProductCheckListTableColumn.Owner,
        value: ProductCheckListTableColumn.Owner,
    },
    {
        label: lt(TextKey.GuestPlural),
        name: ProductCheckListTableColumn.Guests,
        value: ProductCheckListTableColumn.Guests,
    },
];

const claimedProductsOptions: SelectionCardGroupProps['options'] = [
    {
        label: lt(TextKey.InTotal),
        name: ClaimedProductsBy.Total,
        value: ClaimedProductsBy.Total,
    },
    {
        label: lt(TextKey.SplitByAgeCategory),
        name: ClaimedProductsBy.AgeCategories,
        value: ClaimedProductsBy.AgeCategories,
    },
];

export const AdvancedSettingsSectionFIelds: React.FC = () => (
    <Stack vertical spacing={FILTERS_SPACING}>
        <FormSelectionCardGroupField
            label={lt(TextKey.ClaimedProducts)}
            type="radio"
            name={FilterValueKey.claimedProducts}
            options={claimedProductsOptions}
            data-test-id={ProductCheckListFilterFieldsDataTestId.claimProducts}
        />

        <FormSelectionCardGroupField
            required
            label={lt(TextKey.DisplayedColumnPlural)}
            type="checkbox"
            name={FilterValueKey.displayedColumns}
            options={displayedColumnsOption}
            data-test-id={ProductCheckListFilterFieldsDataTestId.displayedColumns}
        />
    </Stack>
);
